import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Typography, Grid, Button } from '@mui/material'
import CountDown from './countdown'
import moment from 'moment'
import RegistrationModal from './registration-modal'
import ReactGA from 'react-ga4'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss'

const portalYoutubeId = '9L9AATQ7deQ'
const myDriveAppYoutubeId = 'wh6imXKgnDU'

const countDownExpiryTimestamp = '2021-06-01 12:00'

const RegistrationOfInterestPage = ({ showForm }) => {

  const countDownExpired = moment() >= moment(countDownExpiryTimestamp, 'YYYY-MM-DD H:mm')

  const mdAndAbove = useMediaQuery('(min-width:960px)')

  const [showVideoId, setShowVideoId] = useState(null)
  const [showRegistrationModal, setShowRegistrationModal] = useState(false)
  const [submittedRegistration, setSubmittedRegistration] = useState(false)
  const [showCountDown, setShowCountDown] = useState(true)

  useEffect(() => {
    ReactGA.event({ category: 'RegistrationOfInterestPage', action: 'View Page', label: 'Registration Of Interest Page' })
  }, [])

  return (
    <div
      style={{
        margin: 0,
        minHeight: '100vh',
        maxHeight: 937,
        backgroundImage: 'url("/static/images/marketing/desktop_background.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        paddingY: '40px',
        paddingX: '20px',
        '@media (max-width: 900px)': {
          paddingY: '20px',
          paddingX: '0px',
        },
        '@media (max-width: 600px)': {
          paddingY: '12px',
          paddingTop: '30px',
          paddingBottom: '0px',
          backgroundPosition: '51% 100%',
          backgroundColor: '#002849',
          backgroundImage: 'none',
        },
      }}>
      <img
        style={{
          width: 400,
          height: 'auto',
          position: 'absolute',
          left: 30,
          top: 50,
          '@media (min-width: 1200px)': {
            left: 150,
          },
          '@media (max-width: 1200px)': {
            left: 150,
          },
          '@media (max-width: 900px)': {
            left: 30,
            top: 20,
          },
          '@media (max-width: 600px)': {
            width: 200,
            top: 20,
            left: '50%',
            transform: 'translate(-50%, 0)',
          },
        }}
        src="/static/images/logo-light.png" alt="logo"/>

      <Grid container>
        <Grid lg={7} md={7} sm={12} xs={12} item
          sx={{
            '@media (max-width: 900px)': {
              margin: '0 -40px 0 40px',
            },
            '@media (max-width: 600px)': {
              margin: '0 16px',
              textAlign: 'center',
            },
          }}>

          <Typography
            sx={{
              color: '#DDDDDD',
              fontSize: '60px',
              fontFamily: 'ProximaNova-Bold',
              lineHeight: '73px',
              '@media (max-width: 900px)': {
                fontSize: '42px',
              },
              '@media (max-width: 600px)': {
                fontSize: '42px',
              },
              '@media (max-width: 0px)': {
                fontSize: '32px',
                lineHeight: '40px',
              },
            }}
            variant="h1">
            A NEW ERA OF{mdAndAbove ? <br /> : ' '}FLEET MANAGEMENT
          </Typography>
          <Typography
            sx={{
              fontSize: '28px',
              fontFamily: 'ProximaNova-Regular',
              lineHeight: '40px',
              color: '#98B6BE',
              marginTop: '40px',
              '@media (max-width: 900px)': {
                fontSize: '20px',
              },
              '@media (max-width: 600px)': {
                fontSize: '20px',
                lineHeight: '20px',
                marginTop: '16px',
                textAlign: 'center',
              },
            }}
            variant="h3">
            Enjoy the benefits and efficiencies<br />of managing your fleet online
          </Typography>

          {!submittedRegistration && showForm && (
            <Button
              variant="contained"
              color="primary"
              sx={{
                margin: '48px 0 16px 0',
                fontFamily: 'ProximaNova-SemiBold',
                width: '380px',
                height: '48px',
                '@media (max-width: 600px)': {
                  margin: '16px 0',
                  width: '100%',
                },
              }}
              onClick={() => setShowRegistrationModal(true)}>
              REGISTER YOUR INTEREST
            </Button>
          )}

          <div
            style={{
              display: 'flex',
              flexFlow: 'row wrap',
              marginTop: '16px',
              '@media (max-width: 960px)': {
                position: 'relative',
                left: '2%',
              },
              '@media (max-width: 875px)': {
                position: 'relative',
                left: '20%',
              },
              '@media (max-width: 600px)': {
                margin: '8px 0',
                position: 'relative',
                left: '10%',
              },
            }}>
            <div
              style={{
                display: 'flex',
                marginTop: 2,
              }}>
              <img
                style={{
                  cursor: 'pointer',
                  display: 'block',
                  width: 'auto',
                  height: '60px',
                  '@media (max-width: 600px)': {
                    height: '40px',
                  },
                }}
                src="/static/images/marketing/video-thumbnail-portal.jpg" // get youtube thumbnail https://img.youtube.com/vi/${youtubeId}/0.jpg
                alt="Video Thumbnail"
                onClick={() => setShowVideoId(portalYoutubeId)}/>

              <Button
                size="small"
                sx={{
                  color: '#FFF',
                  textTransform: 'none',
                  fontSize: '18px',
                  fontFamily: 'ProximaNova-Regular',
                  marginLeft: 2,
                  marginRight: 2,
                  '@media (max-width: 600px)': {
                    fontSize: '16px',
                  },
                }}
                startIcon={<PlayCircleOutlineIcon
                  sx={{
                    color: '#FFF',
                    width: 25,
                    height: 25,
                  }}/>}
                onClick={() => setShowVideoId(portalYoutubeId)}>
                View ToyotaFleet Portal Video
              </Button>
            </div>

            <div
              style={{
                display: 'flex',
                marginTop: 2,
              }}>
              <img
                style={{
                  cursor: 'pointer',
                  display: 'block',
                  width: 'auto',
                  height: '60px',
                  '@media (max-width: 600px)': {
                    height: '40px',
                  },
                }}
                src="/static/images/marketing/video-thumbnail-app.jpg" // get youtube thumbnail https://img.youtube.com/vi/${youtubeId}/0.jpg
                alt="Video Thumbnail"
                onClick={() => setShowVideoId(myDriveAppYoutubeId)}/>

              <Button
                size="small"
                sx={{
                  color: '#FFF',
                  textTransform: 'none',
                  fontSize: '18px',
                  fontFamily: 'ProximaNova-Regular',
                  marginLeft: 2,
                  marginRight: 2,
                  '@media (max-width: 600px)': {
                    fontSize: '16px',
                  },
                }}
                startIcon={<PlayCircleOutlineIcon
                  sx={{
                    color: '#FFF',
                    width: 25,
                    height: 25,
                  }}/>}
                onClick={() => setShowVideoId(myDriveAppYoutubeId)}>
                View Toyota MyDrive Video
              </Button>
            </div>

          </div>

        </Grid>

        <Grid lg={5} md={5} sm={12} xs={12} item
          sx={{
            '@media (min-width: 1200px)': {
              marginLeft: -10,
              marginTop: -8,
            },
            '@media (max-width: 1200px)': {
              marginLeft: -10,
              marginTop: -6,
            },
            '@media (max-width: 900px)': {
              marginLeft: 0,
              marginTop: -2,
            },
            '@media (max-width: 600px)': {
              marginTop: 4,
              width: '100%',
              height: '200px',
              borderRadius: '100% 100% 0 0',
              backgroundColor: '#001324',
            },
            // '@media (max-width: 600px)': {
            //   marginTop: 2,
            // },
          }}>
          {!countDownExpired && showCountDown && (
            <div
              style={{
                '@media (max-width: 600px)': {
                  marginTop: 3,
                  position: 'absolute',
                  left: '50%',
                  transform: 'translate(-50%, 0)',
                },
              }}>
              <CountDown expiryTimestamp={moment(countDownExpiryTimestamp, 'YYYY-MM-DD H:mm')} onExpire={() => setShowCountDown(false)}/>
            </div>
          )}

          <Typography variant="body2"
            sx={{
              paddingTop: 20,
              textAlign: 'center',
              color: '#DDDDDD',
              fontSize: '13px',
              fontFamily: 'ProximaNova-Regular',
              letterSpacing: '0.37px',
              '@media (min-width: 900px)': {
                textAlign: 'center',
                paddingLeft: 0,
              },
              '@media (max-width: 900px)': {
                textAlign: 'left',
                paddingLeft: 10,
              },
              '@media (max-width: 600px)': {
                textAlign: 'center',
                paddingLeft: 0,
                marginTop: 16,
              },

            }}>
            {!countDownExpired && showCountDown && <span style={{ opacity: 0.5, paddingRight: 5 }}>Countdown ends at</span>}
            {!countDownExpired && showCountDown && <span style={{ color: '#FFF' }}>June 1st, 2021 12 PM</span>}
          </Typography>

          <div
            style={{
              backgroundColor: 'transparent',
              '@media (max-width: 600px)': {
                backgroundColor: '#001324',
                height: 500,
                justifyContent: 'center',
              }
            }}>
            <img
              style={{
                height: 'auto',
                backgroundColor: 'transparent',
                position: 'relative',
                left: '50%',
                transform: 'translate(-50%, 0)',
                '@media (min-width: 1200px)': {
                  marginTop: countDownExpired ? -50 : 0,
                  width: countDownExpired ? '700px' : '500px',
                },
                '@media (max-width: 1200px)': {
                  width: countDownExpired ? '600px' : '400px',
                },
                '@media (max-width: 900px)': {
                  width: countDownExpired ? '400px' : '300px',
                },
                '@media (max-width: 600px)': {
                  width: '300px',
                },
              }}
              src="/static/images/marketing/car.png"
              alt="car"/>
          </div>
        </Grid>
      </Grid>

      {/* Registration Modal */}
      {showRegistrationModal && showForm && (
        <RegistrationModal
          open={showRegistrationModal}
          onClose={() => setShowRegistrationModal(false)}
          onHideRegisterButton={() => setSubmittedRegistration(true)}/>
      )}

      {/* Video Modal https://www.npmjs.com/package/react-modal-video */}
      {!!showVideoId && (
        <ModalVideo
          // autoplay
          controls={0}
          showinfo={0}
          channel="youtube"
          isOpen={!!showVideoId}
          videoId={showVideoId}
          onClose={() => setShowVideoId(null)}/>
      )}
    </div>
  )
}

RegistrationOfInterestPage.propTypes = {
  showForm: PropTypes.bool,
}

export default RegistrationOfInterestPage
